document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-trustpilot-title]').forEach((parent) => {
    let iframe = parent.querySelector('iframe');

    if (!iframe) {
      return;
    }

    iframe.onload = function () {
      iframe.setAttribute(
        'title',
        parent.getAttribute('data-trustpilot-title')
      );
    };
  });
});
